import type { ListNodeComponentTypesParams } from '@amarantos/api-client'
import { NodeComponentCategory } from '@amarantos/api-client'
import { z } from 'zod/v3'

export const nodeComponentCategories = Object.values(NodeComponentCategory)

export const categoryFilterValues = ['all', ...nodeComponentCategories] as const

const baseNodeComponentTypesSearchSchema = z.object({
	page: z.coerce.number().int().positive().default(1),
	perPage: z.coerce.number().int().positive().max(100).default(10),
	search: z.string().default(''),
	category: z.enum(categoryFilterValues).default('all'),
})

const drawerSearchStateSchema = z.union([
	z.object({
		mode: z.literal('create'),
		nodeComponentTypeId: z.undefined().optional(),
	}),
	z.object({
		mode: z.literal('edit'),
		nodeComponentTypeId: z.coerce.number().int().positive(),
	}),
	z.object({
		mode: z.undefined().optional(),
		nodeComponentTypeId: z.undefined().optional(),
	}),
])

export const nodeComponentTypesSearchSchema = baseNodeComponentTypesSearchSchema.and(drawerSearchStateSchema)

export type NodeComponentTypesSearch = z.infer<typeof nodeComponentTypesSearchSchema>

export function toListNodeComponentTypesParams(search: NodeComponentTypesSearch): ListNodeComponentTypesParams {
	return {
		page: search.page,
		per_page: search.perPage,
		search: search.search.length > 0 ? search.search : undefined,
		category: search.category === 'all' ? undefined : search.category,
	}
}
